import React from 'react';
import styles from './styles.module.scss';
import EmptyMessage from 'src/components/emptyMessage';

const PageNotFound: React.FC = () => {
  return (
    <div className={styles.container}>
      <EmptyMessage
        width="auto"
        image={'/images/page_not_found.svg'}
        heading="Page not found!"
        message="This page does not exist."
      />
    </div>
  );
};

export default PageNotFound;